<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `The user can edit the Person Type > Status by selecting Enable or Disable. 
          If the Person Type > Status is disabled, not records for that person type will 
          be accepted by the system. `,
          `If the user changes the Header Record Indicator, Detailed Record Indicator, or 
          Footer Record Indicator the submission file extract must be changed accordingly for 
          the system to accept the file. Any extract file that does not match the Header Record 
          Indicator, Detailed Record Indicator, or Footer Record Indicator will be rejected 
          during file validation.`,
          `All display labels may be edited as needed. Required field are set to enabled and 
          cannot be disabled. If a field is set to required, the system will reject all records 
          that do not contain the appropriate data in the required field.`,
          `Click update to save the changes.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
